import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lookup',
  standalone: false
})
export class LookupPipe implements PipeTransform {
  transform(value: any, items: any[], valueProperty: string = 'name', lookupKey: string = 'id'): string {
    if (!value || !items || !Array.isArray(items)) return '';

    const item = items.find(item => item[lookupKey] === value);
    if (!item) return '';

    if (valueProperty.includes('.')) {
      const properties = valueProperty.split('.');
      let result = item;
      for (const prop of properties) {
        result = result?.[prop];
      }
      return result || '';
    }

    return item[valueProperty] || '';
  }
}